import { Icon, IconName, MaybeElement } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"
import QueryBar from "./QueryBar"
type ReactTableHeaderProps = {
  icon?: IconName | MaybeElement
  title?: any
  onQuerySubmit?: any
  onQueryChange?: any
  filter?: any
  children?: React.ReactNode
  value?: string
  className?: string
}
const ReactTableHeader = ({
  icon,
  title,
  onQuerySubmit,
  onQueryChange,
  filter,
  children,
  value,
  className,
}: ReactTableHeaderProps) => {
  return (
    <div
      className={classNames(
        "vt-table-header",
        "mx-3 py-3 flex  items-center",
        className
      )}
    >
      <div className="w-1/4">
        <h5 className="my-0 flex items-center">
          {icon && (
            <Icon
              className="mx-2"
              intent="success"
              color="#293742"
              icon={icon}
            />
          )}
          {title}
        </h5>
      </div>
      <div className="flex justify-center" style={{ width: "40%" }}>
        {(onQueryChange || onQuerySubmit) && (
          <QueryBar
            onSubmit={onQuerySubmit}
            onChange={onQueryChange}
            value={value}
            round={false}
          />
        )}
        {filter ? filter : null}
      </div>
      <div
        className="flex items-center justify-end children"
        style={{ width: "35%" }}
      >
        {children}
      </div>
    </div>
  )
}

export default ReactTableHeader
